import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { campaignsApiPath } from './apiPath';

const CancelRecruitmentApplicationRequestSchema = z
  .object({
    /** 신청 참여 식별자 — 모집형 상세 응답의 participation.id. */
    participationId: z.number().int(),
  })
  .describe('CancelRecruitmentApplicationRequest');

export type CancelRecruitmentApplicationRequest = z.infer<
  typeof CancelRecruitmentApplicationRequestSchema
>;

// NOTE: swagger 상 204 No Content (요청 바디 없음). 응답 본문/래퍼 형태가 없어 unknown 으로 통과시킨다.
// BE 가 본문을 추가하면 createApiResponseSchema 로 교체.
const CancelRecruitmentApplicationResponseSchema = z
  .unknown()
  .describe('CancelRecruitmentApplicationResponse');

export type CancelRecruitmentApplicationResponse = z.infer<
  typeof CancelRecruitmentApplicationResponseSchema
>;

export const cancelRecruitmentApplication = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(CancelRecruitmentApplicationRequestSchema),
    async ({
      participationId,
    }: CancelRecruitmentApplicationRequest): Promise<CancelRecruitmentApplicationResponse> =>
      executeStandardRequest(async () =>
        privateHttpClient.post<CancelRecruitmentApplicationResponse>(
          urlJoin(campaignsApiPath.cancelRecruitmentApplication(participationId)),
          undefined,
          // 204 No Content 빈 본문 JSON 파싱 throw 방지 (성공인데 실패 처리 방지). (SID-4053 동류)
          { responseType: 'text' },
        ),
      ),
    validateApiResponse(CancelRecruitmentApplicationResponseSchema),
  ),
);
